import React from 'react'

const Problems = (props) => {
    let { widgetsPreviewData: Data } = props;
    let noValExistText = <p className="text ar-light-color">No data recorded</p>;

  return (
    <div className="d-flex gap-10">
        <div className="ar-form-counter flex-center">
            <p className='text text-black'>{props?.itemCount}</p>
        </div>
        <div className='d-flex flex-column gap-6 w-100'>
            <p class="heading fs-13">Problems</p>

            {Data?.EncounterProblem?.length > 0 ?
                <div className="d-flex flex-column gap-1">
                {Data.EncounterProblem.map((prob) => (
                    <div className="d-flex align-items-center gap-1">
                    {["true", "True"].includes(prob?.MarkAsPrimary) &&
                    <div className="app_tooltip right">
                        <i className='icon-Star fs-11'></i>
                        <p class="tool_tip xsm_text text-light">Primary Problem</p>
                    </div>}
                    <p className='text font-m validate-color'>{prob.DiagnosisCode}</p>
                    <p className="text">{prob.Description && `- ${prob.Description}${prob.StartDate ? ',' : ''}`}</p>
                    {prob.StartDate ?
                        (<div className="d-flex align-items-center gap-1">
                        <p className='heading'>Start Date:</p>
                        <p className='text'>{prob.StartDate || <span className="text ar-light-color">N/A</span>}</p>
                        </div>) : <></>}
                    </div>
                )
                )}
                </div> :
                <>{noValExistText}</>}
        </div>
    </div>
  )
}

export default Problems